import script from "./popBox.vue?vue&type=script&setup=true&lang=js"
export * from "./popBox.vue?vue&type=script&setup=true&lang=js"

import "./popBox.vue?vue&type=style&index=0&id=6c7d49bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7d49bc"]])

export default __exports__